import { render, staticRenderFns } from "./folderFonts.vue?vue&type=template&id=796cc022&scoped=true&"
import script from "./folderFonts.vue?vue&type=script&lang=js&"
export * from "./folderFonts.vue?vue&type=script&lang=js&"
import style0 from "./folderFonts.vue?vue&type=style&index=0&id=796cc022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cc022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VIcon,VSheet,VSpacer})
